import Model, { belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type SubscriptionUtilisation from 'teacher-ui-client/models/subscription-utilisation'
import type Teacher from 'teacher-ui-client/models/teacher'
import type { SubscriptionStatus } from 'teacher-ui-client/models/school-subscription'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type DateTransform from 'teacher-ui-client/transforms/date'

/**
 * All teacher subscriptions are considered trial subscriptions.
 */
export default class TeacherSubscription extends Model {
  // date transform expects ISO8601 format, backend provides as yyyy-MM-dd format which is technically still ISO8601
  @attr<DateTransform>('date') declare startDate: Date

  @attr<DateTransform>('date') declare endDate: Date

  @attr<StringTransform>('string') declare status: SubscriptionStatus

  @attr<StringTransform>('string') declare subscriptionType: SubscriptionType

  @belongsTo<SubscriptionUtilisation>('subscription-utilisation', { async: false, inverse: 'teacherSubscription' })
  declare subscriptionUtilisation?: SubscriptionUtilisation

  @belongsTo<Teacher>('teacher', { async: false, inverse: 'teacherSubscriptions' }) declare teacher?: Teacher

  get isPending() {
    return this.status === 'pending'
  }

  get isExpired() {
    return this.status === 'expired'
  }

  get isActive() {
    return this.status === 'active'
  }

  [Type] = 'teacher-subscription' as const
}
